<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell *ngIf="companyId || companyGroupId; else noCompany">

  <app-page-hero
    eyebrow="CRM Command Center"
    title="Commercial Pipeline Dashboard"
    subtitle="Sales conversion, quotation velocity, account risk, follow-up workload, and owner performance.">
    <div actions>
      <p-button label="Refresh" icon="pi pi-refresh" (click)="loadDashboard()"></p-button>
      <p-button label="New Lead" icon="pi pi-user-plus" severity="secondary" [outlined]="true" routerLink="/crm/leads/new"></p-button>
      <p-button label="New Quotation" icon="pi pi-file-plus" severity="secondary" [outlined]="true" routerLink="/crm/quotations/new"></p-button>
      <p-button label="Quotations" icon="pi pi-list" severity="secondary" [outlined]="true" routerLink="/crm/quotations"></p-button>
    </div>
  </app-page-hero>

  <app-dashboard-company-scope-selector
    *ngIf="showGroupCompanySelector"
    [companyGroupName]="activeGroupName"
    [memberCompanies]="groupCompanies"
    [selectedCompanyId]="selectedGroupCompanyId"
    (selectedCompanyIdChange)="onDashboardCompanyScopeChange($event)">
  </app-dashboard-company-scope-selector>

  <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

  <app-page-search-panel
    title="Commercial Filters"
    [activeFilters]="activeFilterCount"
    [resultText]="filterResultText"
    (search)="loadDashboard()"
    (clear)="clearFilters()">
    <div class="p-fluid grid formgrid">
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="crmCustomer" pInputText [(ngModel)]="filters.customer">
            <label for="crmCustomer">Customer / Account</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-share-alt"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="crmSource" pInputText [(ngModel)]="filters.source">
            <label for="crmSource">Source</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-inputNumber inputId="crmOwner" [(ngModel)]="filters.ownerId" [useGrouping]="false" [min]="1" styleClass="w-full"></p-inputNumber>
            <label for="crmOwner">Owner ID</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-wallet"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="crmCurrency" [options]="currencyOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.currencyCode" [showClear]="true" styleClass="w-full"></p-select>
            <label for="crmCurrency">Currency</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-user-plus"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="leadStatus" [options]="leadStatusOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.leadStatus" [showClear]="true" styleClass="w-full"></p-select>
            <label for="leadStatus">Lead Status</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-verified"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="prospectStatus" [options]="prospectStatusOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.prospectStatus" [showClear]="true" styleClass="w-full"></p-select>
            <label for="prospectStatus">Prospect Status</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-file-check"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="quoteStatus" [options]="quotationStatusOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.quotationStatus" [showClear]="true" styleClass="w-full"></p-select>
            <label for="quoteStatus">Quotation Status</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-bolt"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="quality" [options]="qualityOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.quality" [showClear]="true" styleClass="w-full"></p-select>
            <label for="quality">Lead / Prospect Quality</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="quotationType" [options]="quotationTypeOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.quotationType" [showClear]="true" styleClass="w-full"></p-select>
            <label for="quotationType">Quotation Type</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="jobType" [options]="jobTypeOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.jobType" [showClear]="true" styleClass="w-full"></p-select>
            <label for="jobType">Job Type</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-id-card"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="businessType" [options]="businessTypeOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.businessType" [showClear]="true" styleClass="w-full"></p-select>
            <label for="businessType">Business Type</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-datePicker inputId="fromDate" [(ngModel)]="filters.fromDate" dateFormat="yy-mm-dd" styleClass="w-full"></p-datePicker>
            <label for="fromDate">From</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-calendar-plus"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-datePicker inputId="toDate" [(ngModel)]="filters.toDate" dateFormat="yy-mm-dd" styleClass="w-full"></p-datePicker>
            <label for="toDate">To</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
    </div>
  </app-page-search-panel>

  <div class="crm-dashboard-grid">
    <div class="funnel-row">
      <app-page-data-panel title="Lifecycle Funnel" subtitle="Lead to prospect to client conversion health." [resultText]="(overview.lifecycleFunnel?.length || 0) + ' stages'">
        <div class="funnel-stack">
          <div class="funnel-stage" *ngFor="let stage of overview.lifecycleFunnel || []">
            <div class="funnel-meta">
              <div>
                <strong>{{ stage.label || label(stage.key) }}</strong>
                <span>{{ funnelAmount(stage) }}</span>
              </div>
              <p-tag [value]="percent(stage.conversionPercent)" [severity]="tagSeverity(stage.tone)"></p-tag>
            </div>
            <div class="funnel-track">
              <span [style.width.%]="funnelWidth(stage)"></span>
            </div>
          </div>
          <div class="table-empty" *ngIf="!(overview.lifecycleFunnel?.length)">No lifecycle data for the selected filters.</div>
        </div>
      </app-page-data-panel>

      <app-page-data-panel title="Quotation Funnel" subtitle="Stage volume, value, probability, and forecast quality." [resultText]="(overview.quotationFunnel?.length || 0) + ' stages'">
        <div class="chart-box short">
          <p-chart type="bar" [data]="quotationFunnelChartData" [options]="funnelChartOptions"></p-chart>
        </div>
        <div class="compact-funnel">
          <div class="compact-stage" *ngFor="let stage of overview.quotationFunnel || []">
            <span>{{ stage.label || label(stage.key) }}</span>
            <strong>{{ formatNumber(stage.count) }}</strong>
            <small>{{ money(stage.weightedAmount) }} weighted</small>
          </div>
        </div>
      </app-page-data-panel>

      <app-page-data-panel title="Risk Queue" subtitle="At-risk pipeline, expired quotes, stalled work, and overdue follow-ups." [resultText]="(overview.riskQueue?.length || 0) + ' risks'">
        <p-table [value]="overview.riskQueue || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '54rem' }">
          <ng-template pTemplate="header">
            <tr><th>Entity</th><th>Issue</th><th>Exposure</th><th>Age / Due</th><th>Severity</th></tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>
                <a class="entity-link" (click)="openRisk(row)">{{ row.entityLabel || label(row.entityType) }}</a>
                <div class="muted">{{ label(row.entityType) }}</div>
              </td>
              <td>
                <div class="strong">{{ row.issue || '-' }}</div>
                <div class="muted">{{ row.recommendation || '-' }}</div>
              </td>
              <td>{{ money(row.amount) }}</td>
              <td>
                <div>{{ row.ageDays !== null && row.ageDays !== undefined ? row.ageDays + 'd' : '-' }}</div>
                <div class="muted">{{ row.dueDate | date:'mediumDate' }}</div>
              </td>
              <td><p-tag [value]="label(row.severity)" [severity]="tagSeverity(row.severity)"></p-tag></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="5"><div class="table-empty">No risk items for the selected filters.</div></td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>
    </div>

    <div class="chart-row primary">
      <app-page-data-panel title="Pipeline Trend" subtitle="Open, weighted, and won value over time.">
        <div class="chart-box tall">
          <p-chart type="line" [data]="pipelineTrendChartData" [options]="lineChartOptions"></p-chart>
        </div>
      </app-page-data-panel>

      <app-page-data-panel title="Acquisition Trend" subtitle="Lead intake, prospect movement, client conversion, and quotation creation.">
        <div class="chart-box tall">
          <p-chart type="bar" [data]="acquisitionTrendChartData" [options]="chartOptions"></p-chart>
        </div>
      </app-page-data-panel>
    </div>

    <div class="chart-row secondary">
      <app-page-data-panel title="Lead Source Mix" subtitle="Inbound and outbound source contribution.">
        <div class="chart-box">
          <p-chart type="doughnut" [data]="leadSourceChartData" [options]="chartOptions"></p-chart>
        </div>
      </app-page-data-panel>
      <app-page-data-panel title="Lead Quality Mix" subtitle="Qualification distribution across active pipeline.">
        <div class="chart-box">
          <p-chart type="polarArea" [data]="leadQualityChartData" [options]="chartOptions"></p-chart>
        </div>
      </app-page-data-panel>
      <app-page-data-panel title="Quotation Status Value" subtitle="Quoted value by commercial approval and client state.">
        <div class="chart-box">
          <p-chart type="doughnut" [data]="quotationStatusChartData" [options]="chartOptions"></p-chart>
        </div>
      </app-page-data-panel>
      <app-page-data-panel title="Owner Performance Radar" subtitle="Pipeline, won value, and overdue workload by owner.">
        <div class="chart-box">
          <p-chart type="radar" [data]="ownerRadarChartData" [options]="chartOptions"></p-chart>
        </div>
      </app-page-data-panel>
    </div>

    <div class="chart-row split">
      <app-page-data-panel title="Quotation Type Value" subtitle="Logistics, storage, POSM, and task value distribution.">
        <div class="chart-box">
          <p-chart type="bar" [data]="quotationTypeChartData" [options]="chartOptions"></p-chart>
        </div>
      </app-page-data-panel>
      <app-page-data-panel title="Job Type Volume" subtitle="Operational work mix behind the quotation pipeline.">
        <div class="chart-box">
          <p-chart type="bar" [data]="jobTypeChartData" [options]="chartOptions"></p-chart>
        </div>
      </app-page-data-panel>
      <app-page-data-panel title="Activity Heatmap" subtitle="CRM touches by activity type and day.">
        <div class="heatmap" *ngIf="heatmapDays.length && heatmapTypes.length; else noHeatmap" [style.--heatmap-days]="heatmapDays.length">
          <div class="heatmap-corner"></div>
          <div class="heatmap-day" *ngFor="let day of heatmapDays">{{ heatmapLabel(day) }}</div>
          <ng-container *ngFor="let activityType of heatmapTypes">
            <div class="heatmap-type">{{ label(activityType) }}</div>
            <div
              class="heatmap-cell"
              *ngFor="let day of heatmapDays"
              [style.background]="heatmapColor(heatmapCount(activityType, day))"
              [class.is-strong]="heatmapCount(activityType, day) >= heatmapMax * 0.55">
              {{ heatmapCount(activityType, day) || '' }}
            </div>
          </ng-container>
        </div>
        <ng-template #noHeatmap>
          <div class="table-empty">No activity heatmap data for the selected filters.</div>
        </ng-template>
      </app-page-data-panel>
    </div>

    <app-page-data-panel title="Top Open Quotations" subtitle="Highest-value open quotations with probability, aging, expiry, and risk." [resultText]="(overview.topOpenQuotations?.length || 0) + ' quotes'">
      <p-table [value]="overview.topOpenQuotations || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '96rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Quotation</th><th>Customer</th><th>Status</th><th>Type / Job</th><th>Total</th><th>Weighted</th><th>Probability</th><th>Age</th><th>Expiry</th><th>Risk</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <a class="entity-link" (click)="openQuotation(row.quotationId)">{{ row.quotationNumber || ('Quotation #' + row.quotationId) }}</a>
              <div class="muted">{{ row.subject || '-' }}</div>
            </td>
            <td>{{ row.customerName || '-' }}</td>
            <td><p-tag [value]="label(row.status)" [severity]="tagSeverity(row.status)"></p-tag></td>
            <td>
              <div class="strong">{{ label(row.type) }}</div>
              <div class="muted">{{ label(row.jobType) }}</div>
            </td>
            <td>{{ money(row.totalAmount, row.currencyCode || undefined) }}</td>
            <td>{{ money(row.weightedAmount, row.currencyCode || undefined) }}</td>
            <td>
              <div class="probability-cell">
                <span>{{ percent(row.probabilityPercent) }}</span>
                <p-progressBar [value]="row.probabilityPercent || 0" [showValue]="false"></p-progressBar>
              </div>
            </td>
            <td>{{ row.ageDays || 0 }}d</td>
            <td>
              <div>{{ row.expiryDate | date:'mediumDate' }}</div>
              <div class="muted">{{ row.daysToExpiry !== null && row.daysToExpiry !== undefined ? row.daysToExpiry + 'd' : '-' }}</div>
            </td>
            <td><p-tag [value]="quoteRiskLabel(row)" [severity]="tagSeverity(row.riskLevel || row.riskReason)"></p-tag></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="10"><div class="table-empty">No open quotations for the selected filters.</div></td></tr>
        </ng-template>
      </p-table>
    </app-page-data-panel>

    <div class="table-row two">
      <app-page-data-panel title="Top Accounts" subtitle="Account pipeline, win value, reminder exposure, and risk level." [resultText]="(overview.topAccounts?.length || 0) + ' accounts'">
        <p-table [value]="overview.topAccounts || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '74rem' }">
          <ng-template pTemplate="header">
            <tr><th>Account</th><th>Source / Owner</th><th>Quotes</th><th>Pipeline</th><th>Won</th><th>Next Follow-up</th><th>Risk</th></tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td><a class="entity-link" (click)="openAccount(row)">{{ row.accountLabel || '-' }}</a></td>
              <td>
                <div>{{ row.source || '-' }}</div>
                <div class="muted">Owner {{ row.ownerId || '-' }}</div>
              </td>
              <td>
                <div class="strong">{{ row.openQuotationCount || 0 }} open</div>
                <div class="muted">{{ row.quotationCount || 0 }} total | {{ row.wonQuotationCount || 0 }} won</div>
              </td>
              <td>{{ money(row.pipelineValue) }}</td>
              <td>{{ money(row.wonValue) }}</td>
              <td>
                <div>{{ row.nextReminderAt | date:'mediumDate' }}</div>
                <div class="muted">Last quote {{ row.lastQuoteAt | date:'mediumDate' }}</div>
              </td>
              <td><p-tag [value]="label(row.riskLevel)" [severity]="tagSeverity(row.riskLevel)"></p-tag></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="7"><div class="table-empty">No account rows for the selected filters.</div></td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>

      <app-page-data-panel title="Activity Queue" subtitle="Open follow-ups and CRM actions due by relation." [resultText]="(overview.activityQueue?.length || 0) + ' activities'">
        <p-table [value]="overview.activityQueue || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '64rem' }">
          <ng-template pTemplate="header">
            <tr><th>Activity</th><th>Relation</th><th>Due</th><th>Status</th><th>Owner</th></tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>
                <div class="strong">{{ row.title || label(row.activityType) }}</div>
                <div class="muted">{{ row.summary || '-' }}</div>
              </td>
              <td>
                <a class="entity-link" (click)="openActivity(row)">{{ row.relationLabel || label(row.relationType) }}</a>
                <div class="muted">{{ label(row.relationType) }}</div>
              </td>
              <td>
                <div>{{ row.dueDate | date:'mediumDate' }}</div>
                <div class="muted">{{ row.dueInDays !== null && row.dueInDays !== undefined ? row.dueInDays + 'd' : '-' }}</div>
              </td>
              <td><p-tag [value]="row.overdue ? 'Overdue' : label(row.status)" [severity]="row.overdue ? 'danger' : tagSeverity(row.tone || row.status)"></p-tag></td>
              <td>{{ row.ownerId || '-' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="5"><div class="table-empty">No activity rows for the selected filters.</div></td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>
    </div>

    <div class="table-row two">
      <app-page-data-panel title="Owner Performance" subtitle="Commercial ownership across leads, prospects, clients, quotations, and follow-up risk." [resultText]="(overview.ownerPerformance?.length || 0) + ' owners'">
        <p-table [value]="overview.ownerPerformance || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '82rem' }">
          <ng-template pTemplate="header">
            <tr><th>Owner</th><th>Leads</th><th>Prospects</th><th>Clients</th><th>Open / Won Quotes</th><th>Pipeline</th><th>Win Rate</th><th>Follow-ups</th><th>Last Activity</th></tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.ownerLabel || ('Owner ' + (row.ownerId || '-')) }}</td>
              <td>{{ formatNumber(row.leadCount) }}</td>
              <td>{{ formatNumber(row.prospectCount) }}</td>
              <td>{{ formatNumber(row.clientCount) }}</td>
              <td>
                <div class="strong">{{ row.openQuotationCount || 0 }} open</div>
                <div class="muted">{{ row.wonQuotationCount || 0 }} won</div>
              </td>
              <td>
                <div>{{ money(row.pipelineValue) }}</div>
                <div class="muted">{{ money(row.weightedPipelineValue) }} weighted</div>
              </td>
              <td>
                <div>{{ percent(row.winRatePercent) }}</div>
                <div class="muted">{{ percent(row.conversionRatePercent) }} conversion</div>
              </td>
              <td>
                <p-tag [value]="(row.overdueReminders || 0) + ' overdue'" [severity]="(row.overdueReminders || 0) > 0 ? 'danger' : 'success'"></p-tag>
                <div class="muted">{{ row.openReminders || 0 }} open</div>
              </td>
              <td>{{ row.lastActivityAt | date:'mediumDate' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="9"><div class="table-empty">No owner performance data for the selected filters.</div></td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>

      <app-page-data-panel title="Source Performance" subtitle="Channel productivity from lead intake through quoted and won value." [resultText]="(overview.sourcePerformance?.length || 0) + ' sources'">
        <p-table [value]="overview.sourcePerformance || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '68rem' }">
          <ng-template pTemplate="header">
            <tr><th>Source</th><th>Leads</th><th>Prospects</th><th>Clients</th><th>Quotes</th><th>Pipeline</th><th>Won</th><th>Rates</th></tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.source || '-' }}</td>
              <td>{{ formatNumber(row.leadCount) }}</td>
              <td>{{ formatNumber(row.prospectCount) }}</td>
              <td>{{ formatNumber(row.clientCount) }}</td>
              <td>
                <div class="strong">{{ row.quotationCount || 0 }}</div>
                <div class="muted">{{ row.wonQuotationCount || 0 }} won</div>
              </td>
              <td>{{ money(row.pipelineValue) }}</td>
              <td>{{ money(row.wonValue) }}</td>
              <td>
                <div>{{ percent(row.leadToClientRate) }} lead to client</div>
                <div class="muted">{{ percent(row.quoteWinRate) }} quote win</div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="8"><div class="table-empty">No source performance data for the selected filters.</div></td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>
    </div>
  </div>
</app-page-shell>

<ng-template #noCompany>
  <app-page-shell>
    <app-page-data-panel title="CRM Dashboard" subtitle="Select a company to load CRM dashboard metrics."></app-page-data-panel>
  </app-page-shell>
</ng-template>
